import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useStoreBase } from "@/lib/store";

/** One homepage request: categories, featured products, and the latest products. */
export function useStoreHomeFeed({ withTags = false } = {}) {
  const { slug, country } = useStoreBase();
  const [categories, setCategories] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [recent, setRecent] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    let live = true;
    const q = new URLSearchParams();
    if (country) q.set("country", country);
    if (withTags) q.set("tags", "1");
    api.get(`/store/${slug}/home-feed${q.toString() ? `?${q.toString()}` : ""}`)
      .then(({ data }) => {
        if (!live || !data) return;
        setCategories(Array.isArray(data.categories) ? data.categories : []);
        setFeatured(Array.isArray(data.featured) ? data.featured : []);
        setRecent(Array.isArray(data.recent) ? data.recent : []);
        setTags(Array.isArray(data.tags) ? data.tags : []);
      })
      .catch(() => {
        if (!live) return;
        setCategories([]);
        setFeatured([]);
        setRecent([]);
        setTags([]);
      });
    return () => { live = false; };
  }, [slug, country, withTags]);

  return { categories, featured, recent, tags };
}
